<template>
    <div class="container">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="text-center mt-4 mb-4">
                    <h1 class="display-4">Privacy Policy</h1>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">General Conditions</h5>
                        <p>
                            By downloading or using the app, these terms will
                            automatically apply to you – you should make sure therefore
                            that you read them carefully before using the app.
                        </p>
                        <p>
                            You’re not allowed to copy or modify the app, any part of the app, or
                            our trademarks in any way.
                        </p>
                        <p>
                            You’re not allowed to attempt to
                            extract the source code of the app, and you also shouldn’t try
                            to translate the app into other languages or make derivative
                            versions.
                        </p>
                        <p>
                            The app itself, and all the trademarks, copyright,
                            database rights, and other intellectual property rights related
                            to it, still belong to Florian Zopf.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Service Changes & Charges</h5>
                        <p>
                            Florian Zopf is committed to ensuring that the app is
                            as useful and efficient as possible.
                        </p>
                        <p>
                            We reserve the right to make changes to the app or to charge for
                            its services, at any time and for any reason.
                        </p>
                        <p>
                            We will never charge you for the app or its services without making it very
                            clear to you exactly what you’re paying for.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Data Security & Privacy</h5>
                        <p>
                            The Qwik VBT app stores and processes personal data that
                            you have provided to us, to provide my
                            Service.
                        </p>
                        <p>
                            In order to provide the online mode feature, we store user data in the cloud. We take the
                            privacy and security
                            of your data very seriously and have implemented industry-standard measures to protect your data
                            from
                            unauthorized access, disclosure, alteration, and destruction.
                        </p>
                        <p>
                            However, please be aware that no method of
                            electronic storage or transmission over the Internet is 100% secure, and we cannot guarantee the
                            absolute
                            security of your data.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Third-Party Services</h5>
                        <p>
                            The app does use third-party services that declare their
                            Terms and Conditions.
                        </p>
                        <p>
                            Link to Terms and Conditions of third-party service
                            providers used by the app
                        </p>
                        <ul>
                            <li><a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Google
                                    Play
                                    Services</a></li>
                        </ul>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Google sign-in</h5>
                        <p>
                            In our app, we offer the option to sign in with Google for your convenience. This process
                            requires us to access your email address, which we use solely as a unique identifier within our
                            app. We respect your privacy: your email is never shared, sold, or used for any other purpose.
                            By choosing to sign in with Google, you consent to this limited use of your email address.
                        </p>
                    </div>
                </div>




                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Responsibility & Usage</h5>
                        <p>
                            Florian Zopf cannot take responsibility for the app not working at full
                            functionality if you don’t have access to Wi-Fi, and you don’t
                            have any of your data allowance left.
                        </p>
                        <p>
                            Along the same lines, Florian Zopf cannot always take
                            responsibility for the way you use the app i.e. You need to
                            make sure that your device stays charged.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Updates & Termination</h5>
                        <p>
                            At some point, we may wish to update the app. Florian Zopf does not promise that it
                            will always update the app so that it is relevant to you
                            and/or works with the Android & iOS version that you have
                            installed on your device.
                        </p>
                        <p>
                            However, you promise to always
                            accept updates to the application when offered to you. We may
                            also wish to stop providing the app, and may terminate use of
                            it at any time without giving notice of termination to you.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Instructions & Optimal Functionality</h5>
                        <p>
                            It is crucial for users to follow the instructions provided within the app to ensure its optimal
                            functionality.
                        </p>
                        <p>
                            Failure to adhere to the instructions may result in inaccurate results and the app may not
                            perform as intended.
                            Florian Zopf cannot be held responsible for any issues or inaccuracies that arise due to the
                            user not following
                            the app's instructions.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Changes to Terms and Conditions</h5>
                        <p>
                            We may update our terms and conditions from time to time to reflect changes to our app and
                            services.
                        </p>
                        <p>
                            Continued use of the app constitutes acceptance of the new terms and conditions. We encourage
                            you to review the terms and
                            conditions periodically for any updates.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Contact Us</h5>
                        <p>
                            If you have any questions or suggestions about
                            my Terms and Conditions, do not hesitate to contact me
                            at qwikvbt@gmail.com.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div></template>
